export default "__VITE_ASSET__68d135c9__"